import { Node } from "@tiptap/pm/model";
import React from "react";
import VideoBlockViewClientsideV1 from "./VideoBlockViewClientsideV1.js";
import VideoBlockViewClientsideV2 from "./VideoBlockViewClientsideV2.js";

interface VideoBlockViewProps {
  node: Node & {
    attrs: {
      src: string;
      poster: string;
      assetId: string;
      playlistUrl?: string;
    };
  };
  className?: string;
  getVideoAspect?: () => void;
}

export type Playlist = {
  id: string;
  title: string;
  description: string;
  poster: string;
  items: Item[];
};

export type Item = {
  src: string;
  type: string;
  label: string;
  width: number;
  height: number;
};

export const VideoBlockViewClientside = (props: VideoBlockViewProps) => {
  if (props.node.attrs.playlistUrl.includes('.json')) {
     return <VideoBlockViewClientsideV1 {...props}/>
   }
   return <VideoBlockViewClientsideV2 {...props}/>
};

export default VideoBlockViewClientside;
